// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  display: flex !important;
  flex-direction: column;
}
.form input, .form textarea {
  border: 1px solid rgb(204, 204, 204);
  border-radius: 2px;
  padding: 5px 10px;
  margin: 3px 10px;
  width: calc(100% - 60px);
}
.form .row {
  display: flex;
  position: relative;
  margin-left: 0px !important;
  margin-bottom: 10px;
}
.form .row label {
  width: 110px;
}
.form .row input, .form .row textarea {
  flex-grow: 1;
}
.form .row textarea {
  min-height: 100px;
}
.form .row button {
  background-color: #eee;
  border: 1px solid rgb(221, 221, 221);
  color: #333;
  font-size: 1em;
  padding: 10px 18px;
  margin: 10px 10px 0 0;
  border-radius: 2px;
}
.form .row button:first-child {
  background: var(--blue);
  color: #fff;
}
.form .error-msg {
  position: absolute !important;
  left: 100%;
  width: 300px;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/contact-us/contact-us.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,sBAAA;AAAF;AAEE;EACE,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAAJ;AAGE;EACE,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AADJ;AAGI;EACE,YAAA;AADN;AAII;EACE,YAAA;AAFN;AAKI;EACE,iBAAA;AAHN;AAMI;EACE,sBAAA;EACA,oCAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAJN;AAMM;EACE,uBAAA;EACA,WAAA;AAJR;AASE;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAPJ","sourcesContent":["\r\n.form {\r\n  display: flex!important;\r\n  flex-direction: column;\r\n\r\n  input, textarea {\r\n    border: 1px solid rgb(204, 204, 204);\r\n    border-radius: 2px;\r\n    padding: 5px 10px;\r\n    margin: 3px 10px;\r\n    width: calc(100% - 60px);\r\n  }\r\n\r\n  .row {\r\n    display: flex;\r\n    position: relative;\r\n    margin-left: 0px!important;\r\n    margin-bottom: 10px;\r\n\r\n    label {\r\n      width: 110px;\r\n    }\r\n\r\n    input, textarea {\r\n      flex-grow: 1;\r\n    }\r\n\r\n    textarea {\r\n      min-height: 100px;\r\n    }\r\n\r\n    button {\r\n      background-color: #eee;\r\n      border: 1px solid rgb(221, 221, 221);\r\n      color: #333;\r\n      font-size: 1em;\r\n      padding: 10px 18px;\r\n      margin: 10px 10px 0 0;\r\n      border-radius: 2px;\r\n      \r\n      &:first-child {\r\n        background: var(--blue);\r\n        color: #fff;\r\n      }\r\n    }\r\n  }\r\n\r\n  .error-msg {\r\n    position: absolute!important;\r\n    left: 100%;\r\n    width: 300px;\r\n    margin-top: 4px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
